import * as Yup from 'yup';
//import {setRequired} from './ArrayUtils';
import { setRequired } from './StrUtils';


const RSSelect = ({qObj}) => {
  let valObj = Yup.string();
  valObj = setRequired(valObj, qObj);
  return valObj;
};

export default RSSelect;